import Loadable from 'react-loadable'
import React, { Component } from 'react';
import { Spin } from 'antd'

function Loading() {
  return (
    <div style={{ textAlign: 'center' }}>
      {/* <Spin style={{marginTop: '60px'}} /> */}
    </div>
  )
}
const Home = Loadable({
  loader: () => import('@/pages/home'),
  loading: Loading
})
const Login = Loadable({
  loader: () => import('@/pages/login'),
  loading: Loading
})
const PersonalCenter = Loadable({
  loader: () => import('@/pages/personalCenter'),
  loading: Loading
})
const LoginLoop = Loadable({
  loader: () => import('@/pages/loginLoop'),
  loading: Loading
})
const LianyunPay = Loadable({
  loader: () => import('@/pages/lianyunPay'),
  loading: Loading
})
const Team = Loadable({
  loader: () => import('@/pages/team'),
  loading: Loading
})
const Registration = Loadable({
  loader: () => import('@/pages/registration'),
  loading: Loading
})
const MonthCard = Loadable({
  loader: () => import('@/pages/monthCard'),
  loading: Loading
})
const Pay = Loadable({
  loader: () => import('@/pages/pay'),
  loading: Loading
})
const ProductList = Loadable({
  loader: () => import('@/pages/pay/productList'),
  loading: Loading
})

const Verified = Loadable({
  loader: () => import('@/pages/verified'),
  loading: Loading
})
const Signin = Loadable({
  loader: () => import('@/pages/signin'),
  loading: Loading
})
const BankPwd = Loadable({
  loader: () => import('@/pages/bankPwd'),
  loading: Loading
})
const Mail = Loadable({
  loader: () => import('@/pages/mail'),
  loading: Loading
})
const Regist = Loadable({
  loader: () => import('@/pages/regist'),
  loading: Loading
})
const BindMobile = Loadable({
  loader: () => import('@/pages/bindMobile'),
  loading: Loading
})
const CardExchange = Loadable({
  loader: () => import('@/pages/cardExchange'),
  loading: Loading
})
const Task = Loadable({
  loader: () => import('@/pages/task'),
  loading: Loading
})
const Fanfanle = Loadable({
  loader: () => import('@/pages/fanfanle'),
  loading: Loading
})
const A202101recharge = Loadable({
  loader: () => import('@/pages/a202101recharge'),
  loading: Loading
})
const A202107fish = Loadable({
  loader: () => import('@/pages/a202107fish'),
  loading: Loading
})
const SetAuditionAddr = Loadable({
  loader: () => import('@/pages/setAuditionAddr'),
  loading: Loading
})
const HealthCheck = Loadable({
  loader: () => import('@/pages/healthCheck'),
  loading: Loading
})

export default [
  {
    path: '/',
    name: 'App',
    title: '个人中心',
    component: PersonalCenter,
    meta: {
      'window-custom': 'width=750&height=470'
    }
  },
  {
    path: '/login',
    name: 'App',
    title: '个人中心',
    component: Login,
    meta: {
      'window-custom': 'width=750&height=470'
    }
  },
  {
    path: '/personalCenter',
    title: '个人中心',
    name: 'personalCenter',
    component: PersonalCenter,
    meta: {
      'window-custom': 'width=750&height=470'
    }
  },
  {
    path: '/home',
    name: 'home',
    component: Home
  },
  {
    path: '/loginLoop',
    name: 'loginLoop',
    component: LoginLoop,
  },
  {
    path: '/lianyunPay',
    title: '传奇支付',
    name: 'lianyunPay',
    component: LianyunPay,
  },
  {
    path: '/team',
    name: 'team',
    title: '战队',
    component: Team,
    meta: {
      'window-custom': 'width=1020&height=670'
    }
  },
  {
    path: '/registration',
    name: 'registration',
    component: Registration,
  },
  {
    path: '/monthCard',
    name: 'monthCard',
    component: MonthCard,
  },
  {
    path: '/pay',
    title: '支付',
    name: 'pay',
    component: Pay,
    meta: { 'window-custom': 'width=670&height=359' }
  },
  {
    path: '/productList',
    title: '充值',
    name: 'productList',
    component: ProductList,
    meta: { 'window-custom': 'width=650&height=359' }
  },
  {
    path: '/verified',
    title: '实名认证',
    name: 'verified',
    component: Verified,
    meta: { 'window-custom': 'width=580&height=320' }
  },
  {
    path: '/signin',
    title: '每日签到得好礼',
    name: 'signin',
    component: Signin,
    meta: { 'window-custom': 'width=750&height=670' }
  },
  {
    path: '/bankPwd',
    title: '修改保险箱密码',
    name: 'bankPwd',
    component: BankPwd,
    meta: { 'window-custom': 'width=460&height=330' }
  },
  {
    path: '/bindMobile',
    title: '绑定手机号',
    name: 'bindMobile',
    component: BindMobile,
    meta: { 'window-custom': 'width=400&height=240' }
  },
  {
    path: '/mail',
    title: '站内信',
    name: 'mail',
    component: Mail,
    meta: { 'window-custom': 'width=730&height=500' }
  },
  {
    path: '/regist',
    title: '注册',
    name: 'regist',
    component: Regist,
    meta: { 'window-custom': 'width=750&height=440&hScroll=0&vScroll=0' }
  },
  {
    path: '/cardExchange',
    title: '礼品卡兑换',
    name: 'cardExchange',
    component: CardExchange,
    meta: { 'window-custom': 'width=380&height=280' }
  },
  {
    path: '/task',
    title: '任务',
    name: 'task',
    component: Task,
    meta: { 'window-custom': 'width=730&height=500' }
  },
  {
    path: '/fanfanle',
    title: 'K7翻翻乐',
    name: 'fanfanle',
    component: Fanfanle,
    meta: { 'window-custom': 'width=1000&height=600' }
  },
  {
    path: '/a202101recharge',
    title: '充值特惠',
    name: 'a202101recharge',
    component: A202101recharge,
    meta: { 'window-custom': 'width=1020&height=572' }
  },
  {
    path: '/A202107fish',
    title: '春节祈福活动',
    name: 'a202107fish',
    component: A202107fish,
    meta: { 'window-custom': 'width=1020&height=625' }
    // meta: { 'window-custom': 'width=1100&height=700' }
  },
  {
    path: '/setAuditionAddr',
    title: '海选地址',
    name: 'setAuditionAddr',
    component: SetAuditionAddr,
    meta: { 'window-custom': 'width=400&height=380' }
  },
  {
    path: '/healthCheck',
    title: '健康检测页',
    name: 'healthCheck',
    component: HealthCheck,
    meta: { 'window-custom': 'width=400&height=380' }
  },
];
